// this could be called `filter_controller` if found to work without search
import { Controller } from "@hotwired/stimulus"
import debounce from "debounce"

export default class extends Controller {
  static targets = ["form", "query", "active", "displayActive", "count", "displayCount", "direction", "sort"]

  initialize(){
    this.submit = debounce(this.submit.bind(this), 450)
  }

  submit() {
    this.persistQueryParams()
    this.formTarget.requestSubmit()
  }

  updateCount(event){
    event.preventDefault()
    this.countTarget.value = event.params.count
    this.displayCountTarget.innerHTML = event.params.count
    this.updatePage()
  }

  updateActive(event){
    event.preventDefault()
    this.activeTarget.value = event.params.active
    this.displayActiveTarget.innerHTML = event.params.active
    this.updatePage()
  }

  updatePage(){
    this.persistQueryParams()
    this.formTarget.requestSubmit()
  }

  persistQueryParams(){
    let queryParams = new URLSearchParams(document.location.search)
    this.directionTarget.value = queryParams.get("direction")
    this.sortTarget.value = queryParams.get("sort")
  }
}
